'use client';

import Navbar from '../common/Navbar';
import TopNavbar from '../common/TopNavbar';
import { usePathname } from 'next/navigation';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  hideNavbar?: boolean;
}

export default function AuthenticatedLayout({
  children,
  hideNavbar = false,
}: AuthenticatedLayoutProps) {
  const pathname = usePathname();

  // Hide navbar for certain report pages or when explicitly requested
  const shouldHideNavbar =
    hideNavbar ||
    pathname?.includes('/reports/generate') ||
    pathname?.includes('/reports/system/generate');

  return (
    <div
      className="min-h-screen bg-[#F5F8F9] relative"
      suppressHydrationWarning
    >
      {/* Centered container for large screens */}
      <div className="max-w-[1920px] mx-auto relative">
        {!shouldHideNavbar && <Navbar />}
        <TopNavbar />
        <main
          className={!shouldHideNavbar ? '[@media(min-width:900px)]:ml-64' : ''}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
